// Configuration file for PortfolioLink module
// Contains shared constants and mappings to avoid duplication

// Category options for forms (string values for form compatibility, matching Link enum)
// Based on Link enum: fxf: 1, fut: 2, opt: 3, div: 4, fee: 5, cash: 6, etc.
export const categoryOptions = [
  { value: "1", label: "FXF" },
  { value: "2", label: "FUT" },
  { value: "3", label: "OPT" },
  { value: "4", label: "DIV" },
  { value: "5", label: "FEE" },
  { value: "6", label: "Cash" },
  { value: "7", label: "Cash as value" },
  { value: "8", label: "Agg div" },
  { value: "10", label: "A3 PnL" },
  { value: "11", label: "A3 PDT" },
  { value: "12", label: "A3 D" },
  { value: "13", label: "Interest" },
  { value: "14", label: "Transfer" },
  { value: "15", label: "Incoming delivery" },
];

// Category mapping from integer to label (used for table display)
// Based on Ruby Link enum mapping: fxf: 1, fut: 2, opt: 3, div: 4, fee: 5, cash: 6, etc.
export const categoryMap: Record<number, string> = {
  1: "FXF",
  2: "FUT",
  3: "OPT",
  4: "DIV",
  5: "FEE",
  6: "Cash",
  7: "Cash as value",
  8: "Agg div",
  10: "A3 PnL",
  11: "A3 PDT",
  12: "A3 D",
  13: "Interest",
  14: "Transfer",
  15: "Incoming delivery",
};

// Client and table constants
export const CLIENT = "instit-quantilia";
export const TABLE_NAME = "links";
